
import {Options} from 'vue-class-component';
import AbstractVue from "@/views/AbstractVue";
import {SelectData} from "@/data/SelectData";

@Options({
  props: [
      "title",
      "icon",
      "optionData",
      "selectedOption"
  ]
})
export default class TestSelect extends AbstractVue {
  title: string;
  icon: string;
  optionData: SelectData[];
  selectedOption: SelectData;

  get selected(): SelectData {
    return this.selectedOption
  }

  set selected(value: SelectData) {
    this.$emit("update", value)
  }
}
